import {AnyLinkType} from 'shared/pretty-easy-navigation/models';

export const TrainerMenu: AnyLinkType[] = [
    {
        type: 'link',
        label: 'navigation.home',
        link: '/home',
    },
    {
        type: 'linkGroup',
        label: 'navigation.contents',
        links: [
            {
                type: 'link',
                label: 'navigation.collections',
                link: '/further/ressources-partenaires-inclusive',
            },
            {
                type: 'link',
                label: 'navigation.lessons',
                link: '/lessons/list',
            },
            {
                type: 'accordionLinkGroup',
                label: 'navigation.corpus_group',
                links: [
                    {
                        type: 'link',
                        label: 'navigation.corpus_global',
                        link: '/corpus/11057',
                    },
                    {
                        type: 'link',
                        label: 'navigation.corpus_user',
                        link: '{{USER_CORPUS_LINK}}',
                    },
                ],
            },
            {
                type: 'link',
                label: 'navigation.self_training',
                link: '/further/formations',
            },
        ],
    },
    {
        type: 'linkGroup',
        label: 'navigation.monitoring_group',
        links: [
            {
                type: 'accordionLinkGroup',
                label: 'navigation.learner_management_group',
                links: [
                    {
                        type: 'link',
                        label: 'navigation.groups_management',
                        link: '/groups/list/groups',
                    },
                    {
                        type: 'link',
                        label: 'navigation.workgroups_management',
                        link: '/groups/list/workgroups',
                    },
                    {
                        type: 'link',
                        label: 'navigation.learners_management',
                        link: '/groups/list/learners',
                    },
                ],
            },
            {
                type: 'link',
                label: 'navigation.self_assignments',
                link: '/followed/tab/self',
            },
        ],
    },
    {
        type: 'linkGroup',
        label: 'navigation.tools',
        links: [
                    {
                        type: 'link',
                        label: 'navigation.notepad',
                        link: '/notepad/list',
                    },
                    {
                        type: 'link',
                        label: 'navigation.mindmap',
                        link: '/mindmap/list',
                    },
        ],
    },
    {
        type: 'linkGroup',
        links: [
            {
                type: 'link',
                label: 'navigation.legal_notice',
                link: '/informations-legales',
            },
            {
                type: 'link',
                label: 'navigation.contact',
                link: '/page/feedback',
            },
            {
                type: 'link',
                label: 'navigation.who_are_we',
                link: '/page/qui-sommes-nous',
            },
            {
                type: 'link',
                label: 'navigation.site_map',
                link: '/page/site-map',
            },
        ],
    },
];
